module.exports = __webpack_public_path__ + "static/media/vigilado-sfc.b558a489.png";